/* import __COLOCATED_TEMPLATE__ from './standalone-preview-selector.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import templateOnlyComponent from '@ember/component/template-only';

interface StandalonePreviewSelectorArgs {
  previewMode: 'agent' | 'copilot';
  onSelectPreviewMode: (mode: 'agent' | 'copilot') => void;
}

const StandalonePreviewSelector = templateOnlyComponent<StandalonePreviewSelectorArgs>();
export default StandalonePreviewSelector;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'FinAiAgent::Knowledge::Previews::StandalonePreviewSelector': typeof StandalonePreviewSelector;
    'fin-ai-agent/knowledge/previews/standalone-preview-selector': typeof StandalonePreviewSelector;
  }
}
